import { Tag, Button } from 'antd'
import { CloudDownloadOutlined } from '@ant-design/icons'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';

// Constant
import { TRANSIT_STATUS_OBJECT, TRIP_STATUS_OBJECT } from '../status'
import { EVENT_TYPES_TITLE, MDVR_TYPES_TITLE } from "../events"

// Component
import GeoLocation from '../../../components/GeoLocation'
import IOTag from '../../../components/Decoration/IOTag'
import VehicleTripStatusTag from '../../../components/VehicleTripStatusTag'
import CellSignalIcon from '../../../components/EventStatusIcon/components/CellSignalIcon'
import GNSSSignalIcon from '../../../components/EventStatusIcon/components/GNSSSignalIcon'

// Handler
import { report_handler } from '../../../handlers'

// Service 
import { RoundUp, TIME } from '../../../services/util'
import { getColumnSearchProps } from '../../../handlers/table'

const {
    parseDuration,
    parseTime,
    parseHours
} = TIME

const {
    DERIVATIVE_DATA_TYPE,
    MILEAGE_TYPE,
    mileageSelector,
    speedSelector
} = report_handler

export const COL_TRANSIT = ({geofences, exportState, searchTextState = '', searchedColumnState = ''}) => [
    {
        title: 'Vehicle',
        key: 'plate',
        dataIndex: 'plate',
        ...getColumnSearchProps("Vehicle", 'plate', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: 'Driver',
        key: 'driver',
        dataIndex: 'driver',
        ...getColumnSearchProps("Driver", 'driver', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: 'Transit Status',
        key: 'transitStatus',
        dataIndex: 'transitStatus',
        filters: Object.keys(TRANSIT_STATUS_OBJECT).map(status => (
            {
                text: status,
                value: TRANSIT_STATUS_OBJECT[status],
            }
        )),
        onFilter: (value, record) => record.transitStatus === value,
        render: (data) => exportState ? data : <VehicleTripStatusTag tripStatus={data}/>
    },
    {
        title: 'Start Date',
        key: 'startTime',
        dataIndex: 'startTime',
        sorter: (a, b) => a.startTime - b.startTime,
        render: (time) => parseTime(time),
    },
    {
        title: 'End Date',
        key: 'endTime',
        dataIndex: 'endTime',
        sorter: (a, b) => a.endTime - b.endTime,
        render: (time) => parseTime(time),
    },
    {
        title: 'Total Duration (hrs)',
        key: 'duration',
        dataIndex: 'duration',
        sorter: (a, b) => a.duration - b.duration,
        render: (data) => parseDuration(data),
    },
    {
        title: 'Start Location',
        key: 'start_loc',
        dataIndex: 'start_loc',
        render: (data, rowData) => exportState ?
            (
                rowData
                &&
                rowData.start_geocoded
                &&
                rowData.start_addr
                || 
                `${data.lat}, ${data.lon}`
            )
            :
            (
                rowData
                &&
                rowData.start_geocoded
                &&
                <GeoLocation location={data} address={rowData.start_addr}/>
                ||
                <GeoLocation location={data}/>
            )
    },
    {
        title: 'Start Address',
        key: 'start_address',
        dataIndex: 'start_address',
        width: 270,
        ...getColumnSearchProps("Start Address", 'start_address', searchTextState, searchedColumnState),
        render: data => data
    },
    {
        title: 'End Location',
        key: 'end_loc',
        dataIndex: 'end_loc',
        render: (data, rowData) => exportState ?
        (
            rowData
            &&
            rowData.end_geocoded
            &&
            rowData.end_addr
            ||
            `${data.lat}, ${data.lon}`
        )
        :
        (
            rowData
            &&
            rowData.end_geocoded
            &&
            <GeoLocation location={data} address={rowData.end_addr}/>
            ||
            <GeoLocation location={data}/>
        )
    },
    {
        title: 'End Address',
        key: 'end_address',
        dataIndex: 'end_address',
        width: 270,
        ...getColumnSearchProps("End Address", 'end_address', searchTextState, searchedColumnState),
        render: data => data
    },
    {
        title: 'Total Mileage (km)',
        key: 'totalMileage',
        render: (rowData) => RoundUp(mileageSelector(rowData, MILEAGE_TYPE.TRIP_MILEAGE), 3),
        sorter: (a, b) => a.totalMileage - b.totalMileage,
    },
    {
        title: "Accumlative Geofence In",
        key: "geoIN",
        dataIndex: "geoIN",
        render: (data) => 
            (
                data
                &&
                data.length 
                && 
                exportState ? 
                (
                    data && data.map(geoid => geoid && geofences[geoid].name).join(', ')
                )
                :
                (
                    data && data.map(geoid => <Tag color="blue" key={geoid}>{geoid && geofences[geoid].name}</Tag>)
                )
            )
            ||
            '-'
    },
    {
        title: "Accumlative Geofence Out",
        key: "geoOUT",
        dataIndex: "geoOUT",
        render: (data) => 
            (
                data
                &&
                data.length 
                && 
                exportState ? 
                (
                    data && data.map(geoid => geoid && geofences[geoid].name).join(', ')
                )
                :
                (
                    data && data.map(geoid => <Tag color="blue" key={geoid}>{geoid && geofences[geoid].name}</Tag>)
                )
            )
            ||
            '-'
    },
]

export const COL_TRIP = ({geofences, exportState, searchTextState = '', searchedColumnState = ''}) => [
    {
        title: 'Vehicle',
        key: 'plate',
        dataIndex: 'plate',
        ...getColumnSearchProps("Vehicle", 'plate', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: 'Driver',
        key: 'driver',
        dataIndex: 'driver',
        ...getColumnSearchProps("Driver", 'driver', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: 'Trip Status',
        key: 'tripStatus',
        dataIndex: 'tripStatus',
        filters: Object.keys(TRIP_STATUS_OBJECT).map(status => (
            {
                text: status,
                value: TRIP_STATUS_OBJECT[status],
            }
        )),
        onFilter: (value, record) => record.tripStatus === value,
        render: (data) => exportState ? data : <VehicleTripStatusTag tripStatus={data}/>
    },
        {
        title: 'Start Date',
        key: 'startTime',
        dataIndex: 'startTime',
        sorter: (a, b) => a.startTime - b.startTime,
        render: (time) => parseTime(time),
    },
    {
        title: 'End Date',
        key: 'endTime',
        dataIndex: 'endTime',
        sorter: (a, b) => a.endTime - b.endTime,
        render: (time) => parseTime(time),
    },
    {
        title: 'Total Duration (hrs)',
        key: 'duration',
        dataIndex: 'duration',
        sorter: (a, b) => a.duration - b.duration,
        render: (data) => parseDuration(data),
    },
    {
        title: 'Start Location',
        key: 'start_loc',
        dataIndex: 'start_loc',
        render: (data, rowData) => exportState ?
            (
                rowData
                &&
                rowData.start_geocoded
                &&
                rowData.start_addr
                ||
                `${data.lat}, ${data.lon}`
            )
            :
            (
                rowData
                &&
                rowData.start_geocoded
                &&
                <GeoLocation location={data} address={rowData.start_addr}/>
                ||
                <GeoLocation location={data}/>
            )
    },
    {
        title: 'Start Address',
        key: 'start_address',
        dataIndex: 'start_address',
        width: 270,
        ...getColumnSearchProps("Start Address", 'start_address', searchTextState, searchedColumnState),
        render: data => data
    },
    {
        title: 'End Location',
        key: 'end_loc',
        dataIndex: 'end_loc',
        render: (data, rowData) => exportState ?
        (
            rowData
            &&
            rowData.end_geocoded
            &&
            rowData.end_addr
            ||
            `${data.lat}, ${data.lon}`
        )
        :
        (
            rowData
            &&
            rowData.end_geocoded
            &&
            <GeoLocation location={data} address={rowData.end_addr}/>
            ||
            <GeoLocation location={data}/>
        )
    },
    {
        title: 'End Address',
        key: 'end_address',
        dataIndex: 'end_address',
        width: 270,
        ...getColumnSearchProps("End Address", 'end_address', searchTextState, searchedColumnState),
        render: data => data
    },
    {
        title: 'Total Mileage (km)',
        key: 'totalMileage',
        render: (rowData) => RoundUp(mileageSelector(rowData, MILEAGE_TYPE.TRIP_MILEAGE), 3),
        sorter: (a, b) => a.totalMileage - b.totalMileage,
    },
    {
        title: "Accumlative Geofence In",
        key: "geoIN",
        dataIndex: "geoIN",
        render: (data) => 
            (
                data
                &&
                data.length 
                && 
                exportState ? 
                (
                    data && data.map(geoid => geoid && geofences[geoid].name).join(', ')
                )
                :
                (
                    data && data.map(geoid => <Tag color="blue" key={geoid}>{geoid && geofences[geoid].name}</Tag>)
                )
            )
            ||
            '-'
    },
    {
        title: "Accumlative Geofence Out",
        key: "geoOUT",
        dataIndex: "geoOUT",
        render: (data) => 
            (
                data
                &&
                data.length 
                && 
                exportState ? 
                (
                    data && data.map(geoid => geoid && geofences[geoid].name).join(', ')
                )
                :
                (
                    data && data.map(geoid => <Tag color="blue" key={geoid}>{geoid && geofences[geoid].name}</Tag>)
                )
            )
            ||
            '-'
    },
    {
        title: "Total Events",
        dataIndex: "totalEvents",
        sorter: (a, b) => a.totalEvents - b.totalEvents,
    },
]

export const COL_DETAIL = ({geofences, FILTER_OUT_ROLE, userRole, exportState}) => [
    {
        title: 'Vehicle',
        key: 'plate',
        dataIndex: 'plate',
        // render: vid => vehicles[vid] && vehicles[vid]?.plate || vid
    },
    {
        title: 'Driver',
        key: 'driver',
        dataIndex: 'driver',
        // render: (drvid) => drvid ? drivers[drvid]?.name : '-'
    },
    {
        title: "Vehicle Time",
        key: 'vehicleTime',
        dataIndex: "vehicleTime",
        render: (time) => parseTime(time),
    },
    {
        title: 'Server Time',
        key: 'createdAt',
        dataIndex: 'createdAt',
        render: (time) => parseTime(time),
        isHidden: FILTER_OUT_ROLE.includes(userRole)
    },
    {
        title: 'Device IMEI',
        key: 'deviceIMEI',
        dataIndex: 'dvid',
        render: (data) => data,
        isHidden: FILTER_OUT_ROLE.includes(userRole)
    },
    {
        title: 'Data Package',
        key: 'devicePackage',
        dataIndex: 'devicePackage',
        render: (data) => data,
        isHidden: FILTER_OUT_ROLE.includes(userRole)
    },
    // {
    //     title: 'Trip Status',
    //     key: 'tripStatus',
    //     dataIndex: 'tripStatus',
    //     filters: Object.keys(TRIP_STATUS_OBJECT).map(status => (
    //         {
    //             text: status,
    //             value: TRIP_STATUS_OBJECT[status],
    //         }
    //     )),
    //     onFilter: (value, record) => record.tripStatus === value,
    //     render: (data) => exportState ? data : <VehicleTripStatusTag tripStatus={data}/>
    // },
    // {
    //     title: 'Transit Status',
    //     key: 'transitStatus',
    //     dataIndex: 'transitStatus',
    //     filters: Object.keys(TRANSIT_STATUS_OBJECT).map(status => (
    //         {
    //             text: status,
    //             value: TRANSIT_STATUS_OBJECT[status],
    //         }
    //     )),
    //     onFilter: (value, record) => record.transitStatus === value,
    //     render: (data) => exportState ? data : <VehicleTripStatusTag tripStatus={data}/>
    // },
    {   title: 'Connectivity',
        key: 'connectivity',
        dataIndex: 'connectivity',
        render: (data) => !exportState ?  <IOTag io={data} textOutput={true} /> :  (data ? 'ON' : 'OFF')
    },
    {   title: 'Cell Signal',
        key: 'cell_signal',
        render: (rowData) => !exportState ? <CellSignalIcon vehicle={rowData}/> : `${rowData.cell_signal || rowData.connectivity }` 
    },
    {
        title: "GPS Status",
        key: "gnss_status",
        render: (rowData) => !exportState ?  <GNSSSignalIcon vehicle={rowData}/> : rowData.gnss_status
    },
    {
        title: "Engine Ignition",
        key: "ignition",
        dataIndex: "ignition",
        render: (data) => !exportState ?  <IOTag io={data} /> :  (data ? 'ON' : 'OFF')
    },
    {
        title: "Location",
        key: "location",
        dataIndex: "location",
        render: (data = {}) => !exportState ? <GeoLocation location={data}/> :`${data.lat}, ${data.lon}`
    },
    {
        title: "Geofence In",
        key: "geoIN",
        dataIndex: "geoIN",
        render: (data) => 
            (
                data
                &&
                data.length 
                && 
                !exportState ? 
                (
                    data && data.map(geoid => <Tag color="blue" key={geoid}>{geoid && geofences[geoid].name}</Tag>)
                )
                :
                (
                    data && data.map(geoid => geoid && geofences[geoid].name).join(', ')
                )
            )
            ||
            '-'
    },
    {
        title: "Geofence Out",
        key: "geoOUT",
        dataIndex: "geoOUT",
        render: (data) => 
            (
                data
                &&
                data.length 
                && 
                !exportState ? 
                (
                    data && data.map(geoid => <Tag color="blue" key={geoid}>{geoid && geofences[geoid].name}</Tag>)
                )
                :
                (
                    data && data.map(geoid => geoid && geofences[geoid].name).join(', ')
                )
            )
            ||
            '-'
    },
    {
        title: "Speed (km/h)",
        key: "speed",
        render: (rowData) => speedSelector(rowData, DERIVATIVE_DATA_TYPE.STATE)
    },
    {
        title: "Altitude",
        key: "altitude",
        dataIndex: "altitude",
        render: (data) => data
    },
    {
        title: "Direction (Degree)",
        key: "heading",
        dataIndex: "heading",
        render: (data) => data
    },
    {
        title: "External Voltage (V)",
        key: "externalVoltage",
        dataIndex: "pwr_ext_v",
        render: (data) => RoundUp(Number(data), 3)
    },
    {
        title: "Battery Voltage (V)",
        key: "batteryVoltage",
        dataIndex: "pwr_int_v",
        render: (data) => RoundUp(Number(data), 3)
    },
    {
        title: "Battery Current (A)",
        key: "batteryCurrent",
        dataIndex: "pwr_int_i",
        render: (data) => RoundUp(Number(data), 3)
    },
    {
        title: 'Digital Output 1',
        key: "do_1",
        dataIndex: "do_1",
        isHidden: FILTER_OUT_ROLE.includes(userRole),
        render: (data) => !exportState ?  <IOTag io={data} textOutput={true} /> : data
    },
    {
        title: 'Digital Input 1',
        key: "di_1",
        dataIndex: "di_1",
        isHidden: FILTER_OUT_ROLE.includes(userRole),
        render: (data) => !exportState ?  <IOTag io={data} textOutput={true} /> :  data
    },
    {
        title: 'Analog Input 1',
        key: "ai_1",
        dataIndex: "ai_1",
        isHidden: FILTER_OUT_ROLE.includes(userRole),
        render: (data) => !exportState ?  <IOTag io={data} textOutput={true} /> :  data  
    }
]

export const COL_DAILY_SUMMARY = ({geofences, exportState, filterPrice,  searchTextState = '', searchedColumnState = ''}) => [
    {
        title: 'Vehicle',
        key: 'plate',
        dataIndex: 'plate',
        ...getColumnSearchProps("Vehicle", 'plate', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    // {
    //     title: 'Driver',
    //     key: 'drvid',
    //     dataIndex: 'drvid',
    //     render: (drvid) => drvid ? drivers[drvid]?.name : '-'
    // },
    {
        title: "Report Date",
        key: 'reportTime',
        dataIndex: "reportTime",
        render: (time) => time,
        sorter: (a, b) => a.reportTime - b.reportTime
    },
    {
        title: "Daily Mileage (km)",
        key: 'plat_daily_mileage',
        // dataIndex: "mileage",
        render: (data) => (
            data
            &&
            !exportState ?
            (
                `${RoundUp(data?.mileage?.total || data.plat_daily_mileage, 2)} km`
            )
            :
            (
                RoundUp(data?.mileage?.total || data.plat_daily_mileage, 2)
            )
        ),
        sorter: (a, b) => (a.mileage.total || a.plat_daily_mileage) - (b.mileage.total || b.plat_daily_mileage)
    },
    {
        title: "Daily Engine Hours (hrs)",
        key: 'plat_daily_engine_hour',
        dataIndex: "plat_daily_engine_hour",
        render: (data) => (
            data
            &&
            !exportState ?
            (
                parseDuration(data)
            )
            :
            (
                // RoundUp(parseHours(data), 2)
                parseDuration(data)
            )
        ),
        sorter: (a, b) => a.plat_daily_engine_hour - b.plat_daily_engine_hour
    },
    {
        title: "Historical Mileage (km)",
        key: 'plat_hist_mileage',
        dataIndex: "plat_hist_mileage",
        render: (data) => (
            data
            &&
            !exportState ?
            (
                `${RoundUp(data, 2)?.toLocaleString('en-US')} km`
            )
            :
            (
                RoundUp(data, 2)?.toLocaleString('en-US')
            )
        ),
        sorter: (a, b) => a.plat_hist_mileage - b.plat_hist_mileage
    },
    {
        title: "Historical Engine Hours (hrs)",
        key: 'plat_hist_engine_hour',
        dataIndex: "plat_hist_engine_hour",
        render: (data) => (
            data
            &&
            !exportState ?
            (
                `${RoundUp(parseHours(data), 2)?.toLocaleString('en-US')} hrs`
            )
            :
            (
                `${RoundUp(parseHours(data), 2)?.toLocaleString('en-US')} hrs`
            )
        ),
        sorter: (a, b) => a.plat_hist_engine_hour - b.plat_hist_engine_hour
    },
    {
        title: "Number of Trip",
        key: 'tripNumber',
        dataIndex: "tripNumber",
        render: (data) => data,
        sorter: (a, b) => a.tripNumber - b.tripNumber
    },
    {
        title: "Total Moving Duration (hrs)",
        key: 'totalMovingDuration',
        dataIndex: "totalMovingDuration",
        render: (data) => (
            data
            &&
            !exportState ?
            (
                parseDuration(data)
            )
            :
            (
                // RoundUp(parseHours(data), 2)
                parseDuration(data)
            )
        ),
        sorter: (a, b) => a.totalMovingDuration - b.totalMovingDuration
        // dataIndex: "duration",
        // render: data => {

        //     return `${RoundUp(data?.totalMovingDuration, 1)} ${data?.unit}`
        // },
        // sorter: (a, b) => a.duration.moving - b.duration.moving
    },
    {
        title: "Total Idling Duration (hrs)",
        key: 'totalIdlingDuration',
        dataIndex: "totalIdlingDuration",
        render: (data) => (
            data
            &&
            !exportState ?
            (
                parseDuration(data)
            )
            :
            (
                // RoundUp(parseHours(data), 2)
                parseDuration(data)
            )
        ),
        sorter: (a, b) => a.totalIdlingDuration - b.totalIdlingDuration
        // dataIndex: "duration",
        // render: data => {

        //     return `${RoundUp(data?.idling, 1)} ${data?.unit}`
        // },
        // sorter: (a, b) => a.duration.idling - b.duration.idling
    },
    {
        title: "Accumlative Geofence In",
        key: "geoIN",
        dataIndex: "geoIN",
        render: (data) => 
            (
                data
                &&
                data.length 
                && 
                !exportState ? 
                (
                    data && data.map(geoid => <Tag color="blue" key={geoid}>{geoid && geofences[geoid].name}</Tag>)
                )
                :
                (
                    data && data.map(geoid => geoid && geofences[geoid].name).join(', ')
                )
            )
            ||
            '-'
    },
    {
        title: "Accumlative Geofence Out",
        key: "geoOUT",
        dataIndex: "geoOUT",
        render: (data) => 
            (
                data
                &&
                data.length 
                && 
                !exportState ? 
                (
                    data && data.map(geoid => <Tag color="blue" key={geoid}>{geoid && geofences[geoid].name}</Tag>)
                )
                :
                (
                    data && data.map(geoid => geoid && geofences[geoid].name).join(', ')
                )
            )
            ||
            '-'
    },
    {
        title: "Fuel Profile",
        key: "FP",
        dataIndex: "FP",
        render: (FP) => 
            (
                !exportState
                &&
                (
                    FP
                    &&
                    <Tag color="green" key={FP}>Have</Tag>
                    ||
                    <Tag color="red" key={FP}>Don't Have</Tag>
                )
                ||
                (
                    FP && 'Have' || `Don't Have`
                )
            )
    },
    {
        title: "Fuel Capacity",
        key: "capacity",
        dataIndex: "capacity",
        sorter: (a, b) => a.capacity - b.data.capacity
    },
    {
        title: "Estimate Fuel Cost Per Liter (RM)",
        key: "fuel_cost",
        render: () => filterPrice
    },
    {
        title: "Total Fuel Consumption (L)",
        key: "FP_0_summary-fuel_consumption-total",
        render: (data) => {
            const FP = data.FP

            return (
                FP
                &&
                RoundUp(data.fuel_consumption.total, 3)
                ||
                '-'
            )
        },
        sorter: (a, b) => a.data.FP_0_capacity - b.data.FP_0_capacity
    },
    {
        title: "Total Estimate Fuel Cost (RM)",
        key: "fuel_cost_total",
        render: (data) => {
            const FP = data.FP

            return (
                FP
                &&
                RoundUp(data.fuel_consumption.total*filterPrice, 3)
                ||
                '-'
            )
        }
    },
    {
        title: "Total Fuel Consumption Rate (L/km)",
        key: "FP_0_summary-fuel_consumption_rate-total",
        render: (data) => {
            const FP = data.FP
            return (
                FP
                &&
                RoundUp(data.fuel_consumption_rate.total, 3)
                ||
                '-'
            )
        }
    },
    {
        title: "Total Fuel Consumption Efficiency (km/L)",
        key: "FP_0_summary-fuel_efficiency-total",
        render: (data) => {
            const FP = data.FP
            return (
                FP
                &&
                RoundUp(data.fuel_efficiency.total, 3)
                ||
                '-'
            )
        }
    },
    {
        title: "Total Moving Fuel Consumption (L)",
        key: "FP_0_summary-fuel_consumption-moving",
        render: (data) => {
            const FP = data.FP
            return (
                FP
                &&
                RoundUp(data.fuel_consumption.moving, 3)
                ||
                '-'
            )
        }
    },
    {
        title: "Total Idling Fuel Consumption (L)",
        key: "FP_0_summary-fuel_consumption-idling",
        render: (data) => {
            const FP = data.FP
            return (
                FP
                &&
                RoundUp(data.fuel_consumption.idling, 3)
                ||
                '-'
            )
        }
    },
    {
        title: "Total Parking Fuel Consumption (L)",
        key: "FP_0_summary-fuel_consumption-parking",
        render: (data) => {
            const FP = data.FP
            return (
                FP
                &&
                RoundUp(data.fuel_consumption.parking, 3)
                ||
                '-'
            )
        }
    }
]

export const COL_GEOFENCE = ({exportState, searchTextState = '', searchedColumnState = ''}) => [
    {
        title: 'Vehicle',
        key: 'plate',
        dataIndex: 'plate',
        ...getColumnSearchProps("Vehicle", 'plate', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: 'Driver',
        key: 'driver',
        dataIndex: 'driver',
        ...getColumnSearchProps("Driver", 'driver', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: "Geofence Template(s)",
        key: 'group',
        dataIndex: "group",
        ...getColumnSearchProps("Geofence Template(s)", 'group', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: "Geofence Name",
        key: 'name',
        dataIndex: "name",
        ...getColumnSearchProps("Geofence Name", 'name', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: "IN",
        // dataIndex: "startTime",
        render: (record) => {
            return exportState ? parseTime(record.startTime) : <>{parseTime(record.startTime)}</>
        },
        sorter: (a, b) => a.startTime - b.startTime
    },
    {
        title: "OUT",
        key: 'geoOUT',
        // dataIndex: "geoOUT",
        // render: (geoOUT) => geoOUT,
        render: (record) => {
            return exportState ? parseTime(record.endTime) : <>{parseTime(record.endTime)}</>
        },
        sorter: (a, b) => a.endTime - b.endTime
    },
    {
        title: "Total Duration (Hrs)",
        key: 'duration',
        dataIndex: "duration",
        render: (data) => (
            data
            &&
            !exportState ?
            (
                parseDuration(data)
            )
            :
            (
                // RoundUp(parseHours(data), 2)
                parseDuration(data)
            )
        ),
        sorter: (a, b) => a.duration - b.duration
    }
]

export const COL_REFUEL_REPORT = ({exportState, searchTextState = '', searchedColumnState = ''}) => [
    {
        title: 'Vehicle',
        key: 'plate',
        dataIndex: 'plate',
        ...getColumnSearchProps("Vehicle", 'plate', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: 'Driver',
        key: 'driver',
        dataIndex: 'driver',
        ...getColumnSearchProps("Driver", 'driver', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: "Fuel Tank #",
        key: 'tank',
        dataIndex: "tank",
        render: (data) => data,
    },
    {
        title: "Fuel Tank Capacity",
        key: 'capacity',
        dataIndex: "capacity",
        render: (data) => data,
        sorter: (a, b) => a.capacity - b.capacity
    },
    {
        title: "Refuel Start Time",
        key: 'startTime',
        dataIndex: "startTime",
        render: (data) => parseTime(data),
        sorter: (a, b) => a.startTime - b.startTime
    },
    {
        title: "Refuel End Time",
        key: 'endTime',
        dataIndex: "endTime",
        render: (data) => parseTime(data),
        sorter: (a, b) => a.endTime - b.endTime
    },
    {
        title: "Start Fuel Level (L)",
        key: 'start_fuel_lvl',
        dataIndex: "start_fuel_lvl",
        render: (data) => RoundUp(data, 2),
        sorter: (a, b) => a.start_fuel_lvl - b.start_fuel_lvl
    },
    {
        title: "End Fuel Level (L)",
        key: 'end_fuel_lvl',
        dataIndex: "end_fuel_lvl",
        render: (data) => RoundUp(data, 2),
        sorter: (a, b) => a.end_fuel_lvl - b.end_fuel_lvl
    },
    {
        title: "Refuel (L)",
        key: 'refuel',
        dataIndex: "refuel",
        render: (data) => RoundUp(data, 2),
        sorter: (a, b) => a.refuel - b.refuel
    },
    {
        title: "Estimated Fuel Cost (RM)",
        key: 'estPrice',
        dataIndex: "estPrice",
        render: (data) => RoundUp(data, 2),
        sorter: (a, b) => a.estPrice - b.estPrice
    },
    {
        title: "Address",
        key: 'location',
        dataIndex: "location",
        render: (data, rowData) => exportState ?
            (
                // data
                // ||
                `${data.lat}, ${data.lon}`
            )
            :
            (
                rowData.address
                &&
                <GeoLocation location={data} address={rowData.address}/>
                ||
                <GeoLocation location={data}/>
            )
    },
]

export const COL_EVENT = ({exportState, searchTextState = '', searchedColumnState = ''}) => [
    {
        title: 'Vehicle',
        key: 'plate',
        dataIndex: 'plate',
        ...getColumnSearchProps("Vehicle", 'plate', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: 'Driver',
        key: 'driver',
        dataIndex: 'driver',
        ...getColumnSearchProps("Driver", 'driver', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: 'Event Type',
        key: 'event_type',
        dataIndex: 'event_type',
        filters: Object.keys(EVENT_TYPES_TITLE).map(sl => {
            return {
                text: <Tag color={EVENT_TYPES_TITLE[sl]?.color}>{EVENT_TYPES_TITLE[sl]?.label}</Tag>,
                value: sl
            }
        }),
        onFilter: (value, record) => record.event_type === Number(value),
        render: (data) => exportState ? EVENT_TYPES_TITLE[data]?.label : <Tag color={EVENT_TYPES_TITLE[data]?.color}>{EVENT_TYPES_TITLE[data]?.label}</Tag>,
    },
    {
        title: 'Event',
        key: 'event',
        dataIndex: 'event',
    },
    {
        title: "Location",
        key: "location",
        dataIndex: "location",
        render: (data = {}) => !exportState ? <GeoLocation location={data}/> :`${data.lat}, ${data.lon}`
    },
    {
        title: 'Remarks',
        key: 'remark',
        dataIndex: 'remark',
        render: (data) => data || '-',
    },
    {
        title: 'Last Updated At',
        key: 'vehicleTime',
        dataIndex: 'vehicleTime',
        render: (time) => parseTime(time),
        sorter: (a, b) => a.vehicleTime - b.vehicleTime
    },
    {
        title: 'Created Date',
        key: 'vehicleTime',
        dataIndex: 'vehicleTime',
        render: (time) => parseTime(time),
        sorter: (a, b) => a.vehicleTime - b.vehicleTime
    },
]

export const COL_THEFT_REPORT = ({exportState, searchTextState = [], searchedColumnState = []}) => [
    {
        title: 'Vehicle',
        key: 'plate',
        dataIndex: 'plate',
        ...getColumnSearchProps("Vehicle", 'plate', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: 'Driver',
        key: 'driver',
        dataIndex: 'driver',
        ...getColumnSearchProps("Driver", 'driver', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: "Fuel Tank #",
        key: 'tank',
        dataIndex: "tank",
        render: (data) => data,
    },
    {
        title: "Fuel Tank Capacity",
        key: 'capacity',
        dataIndex: "capacity",
        render: (data) => data,
        sorter: (a, b) => a.capacity - b.capacity
    },
    {
        title: "Start Date",
        key: 'startTime',
        dataIndex: "startTime",
        render: (data) => parseTime(data),
        sorter: (a, b) => a.startTime - b.startTime
    },
    {
        title: "End Date",
        key: 'endTime',
        dataIndex: "endTime",
        render: (data) => parseTime(data),
        sorter: (a, b) => a.endTime - b.endTime
    },
    {
        title: "Start Fuel Level (L)",
        key: 'start_fuel_lvl',
        dataIndex: "start_fuel_lvl",
        render: (data) => RoundUp(data, 2),
        sorter: (a, b) => a.start_fuel_lvl - b.start_fuel_lvl
    },
    {
        title: "End Fuel Level (L)",
        key: 'end_fuel_lvl',
        dataIndex: "end_fuel_lvl",
        render: (data) => RoundUp(data, 2),
    },
    {
        title: 'Estimated Fuel Theft (L)',
        key: 'theft',
        dataIndex: "theft",
        render: (data) => RoundUp(data, 2),
        sorter: (a, b) => a.end_fuel_lvl - b.end_fuel_lvl

    },
    {
        title: "Estimated Fuel Cost (RM)",
        key: 'estPrice',
        dataIndex: "estPrice",
        render: (data) => RoundUp(data, 2),
        sorter: (a, b) => a.estPrice - b.estPrice
    },
    {
        title: "Address",
        key: 'location',
        dataIndex: "location",
        render: (data, rowData) => exportState ?
            (
                // data
                // ||
                `${data.lat}, ${data.lon}`
            )
            :
            (
                rowData.address
                &&
                <GeoLocation location={data} address={rowData.address}/>
                ||
                <GeoLocation location={data}/>
            )
    },
]
 
export const COL_UTILISATION_REPORT = ({userRole, searchTextState = '', searchedColumnState = ''}) => [
    {
        title: "Date",
        key: 'reportTime',
        dataIndex: "reportTime",
        render: (data) => parseTime(data),
    },
    {
        title: 'Vehicle Plate',
        key: 'plate',
        dataIndex: 'plate',
        ...getColumnSearchProps("Vehicle Plate", 'plate', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
      ...(userRole === 'D'
      ? [
          {
            title: 'Company',
            key: 'company',
            dataIndex: 'company',
            ...getColumnSearchProps("Company", 'company', searchTextState, searchedColumnState),
            render: (data) => data || '-'
          },
        ]
      : []),
    {
        title: 'Engine Hours',
        key: 'engineHours',
        dataIndex: 'plat_daily_engine_hour',
        sorter: (a, b) => a.plat_daily_engine_hour - b.plat_daily_engine_hour,
        render: (data) => `${RoundUp(TIME.parseHours(data), 0)} hrs`
    },
    {
        title: 'Utilisation %',
        key: 'utilisation',
        dataIndex: 'utilisation',
        sorter: (a, b) => a.utilisation - b.utilisation,
        render: (data) => data.toFixed(2) || '-'
    },
    {
        title: 'Distance Travelled',
        key: 'distanceTravelled',
        dataIndex: 'plat_daily_mileage',
        sorter: (a, b) => a.plat_daily_mileage - b.plat_daily_mileage,
        render: (data) => data.toFixed(2) || '-'
    },
    // {
    //     title: 'Expected Distance',
    //     key: 'distanceExpected',
    //     dataIndex: 'distanceExpected',
    //     render: (data) => data || 0
    // },
    // {
    //     title: 'Overall Utilisation %',
    //     key: 'utilisation_rate',
    //     dataIndex: 'utilisation_rate',
    // },
]

export const COL_MDVR_EVENT = ({ userCam, exportState, searchTextState = '', searchedColumnState = '' }) => [
    {
        title: "Datetime",
        key: 'startTime',
        dataIndex: "startTime",
        render: (data) => parseTime(data),
        sorter: (a, b) => a.startTime - b.startTime,
    },
    {
        title: 'Vehicle Plate',
        key: 'plate',
        dataIndex: 'plate',
        ...getColumnSearchProps("Vehicle Plate", 'plate', searchTextState, searchedColumnState),
        render: data => data || '-'
    },
    {
        title: 'Driver',
        key: 'driver',
        dataIndex: 'driver',
        ...getColumnSearchProps("Driver", 'driver', searchTextState, searchedColumnState),
        render: data => data || '-'
    },
    {
        title: 'Event Name',
        key: 'eventName',
        dataIndex: 'eventName',
        ...getColumnSearchProps("Event Name", 'eventName', searchTextState, searchedColumnState),
        render: data => data || '-'
    },
    {
        title: 'Type',
        key: 'type',
        dataIndex: 'type',
        filters: Object.keys(MDVR_TYPES_TITLE).map(type => {
            return {
                text: type,
                value: type
            }
        }),
        onFilter: (value, record) => record.type === value,
    },
    {
        title: 'Channel',
        key: 'channelNum',
        dataIndex: 'channelNum',
        ...getColumnSearchProps("Channel", 'channelNum', searchTextState, searchedColumnState),
        render: data => data || '-'
    },
    {
        title: "Location",
        key: "location",
        dataIndex: "location",
        render: (data = {}) => !exportState ? <GeoLocation location={data}/> :`${data.lat}, ${data.lon}`
    },
    {
        title: exportState ? 'Video Link' : 'Action',
        key: 'action',
        render: data => {

            const Data = data.originalData
            const videolink = `https://202.126.209.190:6063/DownloadRecordFile.php?User=${userCam.UserName}&GlobalSessionId=${userCam.SessionId}&FileId=${Data.FileId}`

            const downloadVideo = () => {
                window.open(videolink)
            }

            return exportState ? videolink :
                <CloudDownloadOutlined onClick={downloadVideo} />
            
        }
    },

]

export const COL_PASSENGER_COUNT = ({ exportState, searchTextState = '', searchedColumnState = '' }) => [
    {
        title: "Datetime",
        key: 'time',
        dataIndex: "time",
        // render: (data) => parseTime(data),
    },
    {
        title: 'Vehicle',
        key: 'plate',
        dataIndex: 'plate',
        ...getColumnSearchProps("Vehicle", 'plate', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: "Location",
        key: "location",
        dataIndex: "location",
        render: (data = {}) => !exportState ? <GeoLocation location={data}/> :`${data.lat}, ${data.lon}`
    },
    {
        title: 'Driver',
        key: 'driver',
        dataIndex: 'driver',
    },
    {
        title: 'In',
        key: 'in',
        dataIndex: 'in',
    },
    {
        title: 'Out',
        key: 'out',
        dataIndex: 'out',
    },
    {
        title: 'Total',
        key: 'total',
        dataIndex: 'total',
    },

]

export const COL_DISCONNECTED = ({ exportState, searchTextState = '', searchedColumnState = '' }) => [
    {
        title: 'Vehicle Plate',
        key: 'plate',
        dataIndex: 'plate',
        ...getColumnSearchProps("Vehicle Plate", 'plate', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: 'Device',
        key: 'device',
        dataIndex: 'device',
        ...getColumnSearchProps("Device", 'device', searchTextState, searchedColumnState),
        render: (data) => data || '-'
    },
    {
        title: "Location",
        key: "location",
        dataIndex: "location",
        render: (data = {}) => !exportState ? <GeoLocation location={data}/> :`${data.lat}, ${data.lon}`
    },
    {
        title: 'Start Date',
        key: 'startTime',
        dataIndex: 'startTime',
    },
    {
        title: 'End Date',
        key: 'endTime',
        dataIndex: 'endTime',
    },
    {
        title: 'Duration',
        key: 'duration',
        dataIndex: 'duration',
        sorter: (a, b) => a.duration - b.duration,
        render: (data) => parseDuration(data),
    }

]

export const COL_REFUEL_EVENTS = ({exportState, searchTextState = '', searchedColumnState = '', receiptHDLR }) => [
    {
        title: "Start Time", 
        key: 'startTime',
        dataIndex: "startTime",
        render: (data) => parseTime(data),
        sorter: (a, b) => a.startTime - b.startTime
    },
    {
        title: "End Time",
        key: 'endTime',
        dataIndex: "endTime",
        render: (data) => parseTime(data),
        sorter: (a, b) => a.endTime - b.endTime
    },
    {
        title: "Fuel (L)",
        key: 'fuel',
        dataIndex: "fuel",
        render: (data) => RoundUp(data, 2),
        sorter: (a, b) => a.fuel - b.fuel
    },
    {
        title: "Cost (RM)",
        key: 'cost',
        dataIndex: "cost",
        render: (data) => RoundUp(data, 2),
        sorter: (a, b) => a.cost - b.cost
    },
    {
        title: "Location",
        key: 'location',
        dataIndex: "location",
        render: (data, rowData) => exportState ?
            (
                // data
                // ||
                `${data.lat}, ${data.lon}`
            )
            :
            (
                rowData.address
                &&
                <GeoLocation location={data} address={rowData.address}/>
                ||
                <GeoLocation location={data}/>
            )
    },
    {
        title: "Receipt",
        key: 'attachment',
        // dataIndex: "attachment",
        render: (data) => {

            const MODE = {
                'VIEW': {
                    icon: <ReceiptOutlinedIcon />,
                    label: 'View'
                },
                'UPLOAD': {
                    icon: <FileUploadOutlinedIcon />,
                    label: 'Upload'
                }
            }

            const DATA_MODE = data.attachment ? 'VIEW' : 'UPLOAD'
            
            return <Button icon={MODE[DATA_MODE]?.icon} onClick={() => receiptHDLR(data)}>{MODE[DATA_MODE]?.label}</Button>
        }
    },
        {
        title: "Review Time", 
        key: 'reviewTime',
        dataIndex: "startTime",
        render: (data) => parseTime(data),
        sorter: (a, b) => a.reviewTime - b.reviewTime
    },
    {
        title: "Reviewed By",
        key: 'reviewedBy',
        dataIndex: "reviewedBy",
         ...getColumnSearchProps("ReviewedBy", 'reviewedBy', searchTextState, searchedColumnState),
        // render: (data) => parseTime(data),
        // sorter: (a, b) => a.endTime - b.endTime
    },
]

export const COL_THEFT_EVENTS = ({exportState }) => [
    {
        title: "Start Time", 
        key: 'startTime',
        dataIndex: "startTime",
        render: (data) => parseTime(data),
        sorter: (a, b) => a.startTime - b.startTime
    },
    {
        title: "End Time",
        key: 'endTime',
        dataIndex: "endTime",
        render: (data) => parseTime(data),
        sorter: (a, b) => a.endTime - b.endTime
    },
    {
        title: "Est. Loss (L)",
        key: 'fuel',
        dataIndex: "fuel",
        render: (data) => RoundUp(data, 2),
        sorter: (a, b) => a.fuel - b.fuel
    },
    {
        title: "Est. Cost (MYR)",
        key: 'cost',
        dataIndex: "cost",
        render: (data) => RoundUp(data, 2),
        sorter: (a, b) => a.cost - b.cost
    },
    {
        title: "Location",
        key: 'location',
        dataIndex: "location",
        render: (data, rowData) => exportState ?
            (
                // data
                // ||
                `${data.lat}, ${data.lon}`
            )
            :
            (
                rowData.address
                &&
                <GeoLocation location={data} address={rowData.address}/>
                ||
                <GeoLocation location={data}/>
            )
    },
]
